import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { OutletQrCodeView } from "./OutletQrCodeView";

export const outletQrCodeRoutes = [
    {
        path: "/outlet-qr-code",
        exact: true,
        element: <AuthorizedRoute moduleIds={[]} allowFullAccess><OutletQrCodeView /></AuthorizedRoute>
    },
]